// extracted by mini-css-extract-plugin
export default {"MainLayout":"mainLayout_MainLayout__YuAMu","wrapper":"mainLayout_wrapper__oNti-"};